import type { ProjectLabel, ProjectUser } from "@/components/ProjectList/types";
import type { Project } from "@/utils/types";

/**
 * Safely converts project labels from JSON to ProjectLabel array
 */
export const getProjectLabels = (
  labels: Project["labels"] | undefined,
): ProjectLabel[] => {
  return Array.isArray(labels) ? (labels as ProjectLabel[]) : [];
};

/**
 * Safely converts project users from JSON to ProjectUser array
 */
export const getProjectUsers = (
  users: Project["users"] | undefined,
): ProjectUser[] => {
  return Array.isArray(users) ? (users as ProjectUser[]) : [];
};
